<template>
    <div>
        <Transition
            name="fade"
            mode="out-in"
        >
            <div
                v-show="hasBookings"
                class="Bookings"
            >
                <PageTitle class="Bookings-title">
                    {{ $t('personal-account.bookings.title') }}
                </PageTitle>
                <div class="Bookings-globalContainer">
                    <div class="Bookings-allServiceContainer">
                        <div
                            v-if="arrayCarsharingsByYear.length > 0"
                            class="Bookings-serviceContainer"
                        >
                            <div class="Bookings-service">
                                {{ $t('personal-account.bookings.service.carsharing') }}
                            </div>
                            <Block
                                :withoutPadding="true"
                            >
                                <div
                                    v-for="(yearObject, index) in arrayCarsharingsByYear"
                                    :key="index"
                                    class="Bookings-yearContainer"
                                >
                                    <div class="Bookings-year">
                                        {{ yearObject.year }}
                                    </div>
                                    <List :items="yearObject.carsharings">
                                        <template #listItem="{item}">
                                            <BookingItem
                                                :booking="item"
                                            />
                                        </template>
                                    </List>
                                </div>
                                <div
                                    id="carsharingLoadMoreButton"
                                    class="Bookings-loadMoreContainer"
                                >
                                    <RoundedButton
                                        v-if="carsharings.length < carsharingsCount"
                                        :label="$t('personal-account.bookings.show-more')"
                                        type="reversed"
                                        class="Bookings-loadMoreButton"
                                        data-cy="button.carsharing.loadMore"
                                        @buttonClicked="loadMoreCarsharings"
                                    />
                                </div>
                            </Block>
                        </div>
                        <div
                            v-if="arrayRentsByYear.length > 0"
                            class="Bookings-serviceContainer"
                        >
                            <div class="Bookings-service">
                                {{ $t('personal-account.bookings.service.rent') }}
                            </div>
                            <Block
                                :withoutPadding="true"
                            >
                                <div
                                    v-for="(yearObject, index) in arrayRentsByYear"
                                    :key="index"
                                    class="Bookings-yearContainer"
                                >
                                    <div class="Bookings-year">
                                        {{ yearObject.year }}
                                    </div>
                                    <List :items="yearObject.rents">
                                        <template #listItem="{item}">
                                            <BookingItem
                                                :booking="item"
                                            />
                                        </template>
                                    </List>
                                </div>
                                <div
                                    id="rentLoadMoreButton"
                                    class="Bookings-loadMoreContainer"
                                >
                                    <RoundedButton
                                        v-if="rents.length < rentsCount"
                                        :label="$t('personal-account.bookings.show-more')"
                                        type="reversed"
                                        class="Bookings-loadMoreButton"
                                        data-cy="button.rent.loadMore"
                                        @buttonClicked="loadMoreRents"
                                    />
                                </div>
                            </Block>
                        </div>
                        <div
                            v-if="arrayParksByYear.length > 0"
                            class="Bookings-serviceContainer"
                        >
                            <div class="Bookings-service">
                                {{ $t('personal-account.bookings.service.park') }}
                            </div>
                            <Block
                                :withoutPadding="true"
                            >
                                <div
                                    v-for="(yearObject, index) in arrayParksByYear"
                                    :key="index"
                                    class="Bookings-yearContainer"
                                >
                                    <div class="Bookings-year">
                                        {{ yearObject.year }}
                                    </div>
                                    <List :items="yearObject.parks">
                                        <template #listItem="{item}">
                                            <BookingItem
                                                :booking="item"
                                            />
                                        </template>
                                    </List>
                                </div>
                                <div
                                    id="parkLoadMoreButton"
                                    class="Bookings-loadMoreContainer"
                                >
                                    <RoundedButton
                                        v-if="parks.length < parksCount"
                                        :label="$t('personal-account.bookings.show-more')"
                                        type="reversed"
                                        class="Bookings-loadMoreButton"
                                        data-cy="button.park.loadMore"
                                        @buttonClicked="loadMoreParks"
                                    />
                                </div>
                            </Block>
                        </div>
                    </div>

                    <div class="Bookings-filter">
                        <CircleIconButton
                            class="Bookings-filterButton"
                            icon="f2m-filter"
                            data-cy="button.filter"
                            @buttonClicked="toggleFiltersModal"
                        />
                    </div>
                </div>
            </div>
        </Transition>
        <Transition
            name="fade"
            mode="out-in"
        >
            <div
                v-show="hasBookings===false"
                class="Bookings"
            >
                <div class="Bookings-empty">
                    <span class="f2m-calendar Bookings-emptyIcon" />
                    <div class="Bookings-emptyTitle">
                        {{ $t('personal-account.bookings.empty.title') }}
                    </div>
                    <div class="Bookings-emptyDescription">
                        {{ $t('personal-account.bookings.empty.description') }}
                    </div>
                </div>
            </div>
        </Transition>
        <FullScreenModal
            :showModal="showFiltersModal"
            type="custom"
            class="Bookings-filterModal"
        >
            <div class="col col-sm-12 col-md-6 offset-md-3">
                <div class="Bookings-filterModalHeader">
                    <div class="Bookings-filterModalHeaderTitle">
                        {{ $t('personal-account.bookings.filter.title') }}
                    </div>
                    <RoundedButton
                        type="white"
                        :label="$t('personal-account.bookings.filter.reset')"
                        data-cy="button.reset"
                        @buttonClicked="resetFilters"
                    />
                </div>
                <div class="Bookings-filterModalSubTitle">
                    {{ $t('personal-account.bookings.filter.byServices') }}
                </div>
                <div class="Bookings-filterModalServiceContainer">
                    <div class="row">
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.bookings.filter.all')"
                                class="Bookings-filterModalServiceButton"
                                :active="selectedService === 'all'"
                                data-cy="button.all"
                                @buttonClicked="selectFilterService('all')"
                            />
                        </div>
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.bookings.filter.carsharing')"
                                class="Bookings-filterModalServiceButton"
                                :active="selectedService === 'carsharing'"
                                data-cy="button.carsharing"
                                @buttonClicked="selectFilterService('carsharing')"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.bookings.filter.rent')"
                                class="Bookings-filterModalServiceButton"
                                :active="selectedService === 'rent'"
                                data-cy="button.rent"
                                @buttonClicked="selectFilterService('rent')"
                            />
                        </div>
                        <div class="col col-6">
                            <RoundedButton
                                type="white"
                                :label="$t('personal-account.bookings.filter.park')"
                                class="Bookings-filterModalServiceButton"
                                :active="selectedService === 'park'"
                                data-cy="button.park"
                                @buttonClicked="selectFilterService('park')"
                            />
                        </div>
                    </div>
                </div>
                <div class="Bookings-filterModalSubTitle">
                    {{ $t('personal-account.bookings.filter.byDate') }}
                </div>
                <div class="Bookings-filterModalDateContainer row">
                    <div class="col col-12 col-md-6">
                        <InputDropdown
                            v-model="selectedYear"
                            :label="$t('personal-account.bookings.filter.years')"
                            :items="years"
                            class="Bookings-inputDropdown"
                            data-cy="dropdown.year"
                        />
                    </div>
                    <div class="col col-12 col-md-6">
                        <InputDropdown
                            v-model="selectedMonth"
                            :label="$t('personal-account.bookings.filter.month')"
                            :items="months"
                            class="Bookings-inputDropdown"
                            :disabled="selectedYear === '0'"
                            data-cy="dropdown.month"
                        />
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="Bookings-filterModalFooter row">
                    <div class="col col-sm-12 col-md-6 offset-md-3 ">
                        <div class="row">
                            <div class="col col-4 col-md-3 offset-md-1">
                                <RoundedButton
                                    :label="$t('personal-account.bookings.filter.cancel')"
                                    class="Bookings-filterModalFooterButton"
                                    data-cy="button.cancel"
                                    @buttonClicked="toggleFiltersModal"
                                />
                            </div>
                            <div class="col col-8 col-md-7">
                                <RoundedButton
                                    :label="$t('personal-account.bookings.filter.submit', {count})"
                                    type="reversed"
                                    class="Bookings-filterModalSubmitButton Bookings-filterModalFooterButton"
                                    :loading="loading"
                                    :inactive="count === 0"
                                    data-cy="button.submit"
                                    @buttonClicked="submitFilters"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </FullScreenModal>
    </div>
</template>

<script>


import PageTitle from '@/components/PageTitle.vue';
import Transition from "@/components/Transition.vue"
import List from "@/components/List.vue";
import BookingItem from "@/components/BookingItem.vue";

import Component from 'vue-class-component'
import Vue from 'vue'
import dayjs from "dayjs";
import _ from "lodash";
import * as mutationTypes from "@/store/mutation-types";
import {Block} from "@free2move/vuejs-components";
import RoundedButton from "@/components/common/RoundedButton.vue";


import {CarsharingStatus, RentStatus, ParkStatus} from "@free2move/enum-values";
import {
    GET_CARSHARINGS,
    GET_RENTS,
    GET_PARKS,
} from "@/store/action-types";
import FullScreenModal from "@/components/FullScreenModal.vue";
import CircleIconButton from "@/components/CircleIconButton.vue";
import InputDropdown from "@/components/common/InputDropdown.vue";

@Component({
    computed: {
        dayjs() {
            return dayjs
        }
    },
    components: {
        FullScreenModal,
        PageTitle,
        Transition,
        Block,
        List,
        BookingItem,
        RoundedButton,
        CircleIconButton,
        InputDropdown
    },
    watch: {
        selectedService() {
            this.countResults();
        },
        selectedYear() {
            if (this.selectedYear === '0')
                this.selectedMonth = '0';
            this.countResults();
        },
        selectedMonth() {
            this.countResults();
        },
    }
})
export default class Bookings extends Vue {
    data() {
        return {
            carsharings: [],
            carsharingsCount: null,
            hasBookings: null,
            rents: [],
            rentsCount: null,
            hasRents: null,
            parks: [],
            parksCount: null,
            hasParks: null,
            count: 0,
            selectedService: 'all',
            selectedYear: '0',
            selectedMonth: '0',
            initialValues: {
                selectedYear: '0',
                selectedMonth: '0',
                selectedService: 'all'
            },
            showFiltersModal: false,
            loading: false,
        }
    }

    get arrayCarsharingsByYear() {
        const array = this.carsharings.reduce((acc, carsharing) => {
            const year = dayjs(carsharing.from.date).format('YYYY');
            const keyYear = _.findIndex(acc, (item) => item.year === year);
            if (keyYear === -1) {
                acc.push({
                    year,
                    carsharings: [carsharing]
                });
            } else {
                acc[keyYear].carsharings.push(carsharing);
            }
            return acc.map((yearObject) => {
                return {
                    ...yearObject,
                    carsharings: _.sortBy(yearObject.carsharings, (carsharing) => {
                        return dayjs(carsharing.from.date).format('YYYYMMDD');
                    }).reverse()
                }
            })
        }, []);
        return _.sortBy(array, 'year').reverse();
    }

    get arrayRentsByYear() {
        const array = this.rents.reduce((acc, rent) => {
            const year = dayjs(rent.from.date).format('YYYY');
            const keyYear = _.findIndex(acc, (item) => item.year === year);
            if (keyYear === -1) {
                acc.push({
                    year,
                    rents: [rent]
                });
            } else {
                acc[keyYear].rents.push(rent);
            }
            return acc.map((yearObject) => {
                return {
                    ...yearObject,
                    rents: _.sortBy(yearObject.rents, (rent) => {
                        return dayjs(rent.from.date).format('YYYYMMDD');
                    }).reverse()
                }
            })
        }, []);
        return _.sortBy(array, 'year').reverse();
    }

    get arrayParksByYear() {
        const array = this.parks.reduce((acc, park) => {
            const year = dayjs(park.from.date).format('YYYY');
            const keyYear = _.findIndex(acc, (item) => item.year === year);
            if (keyYear === -1) {
                acc.push({
                    year,
                    parks: [park]
                });
            } else {
                acc[keyYear].parks.push(park);
            }
            return acc.map((yearObject) => {
                return {
                    ...yearObject,
                    parks: _.sortBy(yearObject.parks, (park) => {
                        return dayjs(park.from.date).format('YYYYMMDD');
                    }).reverse()
                }
            })
        }, []);
        return _.sortBy(array, 'year').reverse();
    }

    mounted() {
        this.getBookings();
        this.countResults();
    }

    getBookings() {
        this.carsharings = [];
        this.rents = [];
        this.parks = [];

        switch(this.conditions.service) {
            case 'carsharing':
                this.getCarsharings();
                this.getCarsharingsCount();
                break;
            case 'rent':
                this.getRents();
                this.getRentsCount();
                break;
            case 'park':
                this.getParks();
                this.getParksCount();
                break;
            default:
                this.getCarsharings();
                this.getCarsharingsCount();
                this.getRents();
                this.getRentsCount();
                this.getParks();
                this.getParksCount();
                break;
        }

    }

    scrollToElement(elId) {
        setTimeout(() => {
            const el = document.getElementById(elId);
            const rect = el.getBoundingClientRect();
            const top = rect.top + window.scrollY;
            window.scrollTo({top:top - (window.screen.height - 300), behavior: 'smooth'});
        }, 200);
    }

    getCarsharingsCount(fromDate) {
        return new Promise((resolve) => {
            const carsharingStatuses = _(CarsharingStatus).values().without(CarsharingStatus.INIT, CarsharingStatus.CANCELLED).value();
            this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
            this.$store.dispatch(GET_CARSHARINGS, {
                callback: function (data) {
                    this.carsharingsCount = data.count;
                    this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                    resolve(data.count);
                }.bind(this),
                data: {
                    conditions: {
                        status: {$in: carsharingStatuses},
                        ...this.conditions.date,
                        ...(fromDate ? {'from.date': {$gte: fromDate}} : {})
                    },
                    count: true,
                }
            });
        })

    }
    getCarsharings(params) {
        const carsharingStatuses = _(CarsharingStatus).values().without(CarsharingStatus.INIT, CarsharingStatus.CANCELLED).value();
        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
        this.$store.dispatch(GET_CARSHARINGS, {
            callback: function (data) {
                this.carsharings = [...this.carsharings, ...data];
                this.hasBookings = this.hasBookings || this.carsharings.length > 0;
                if(params.fromLoadMore) this.scrollToElement('carsharingLoadMoreButton');
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
            }.bind(this),
            data: {
                conditions: {
                    status: {$in: carsharingStatuses},
                    ...this.conditions.date
                },
                skip: params?.skip || 0,
                limit: params?.limit || 5,
                sort: {
                    'from.date': -1
                }
            }
        });
    }
    loadMoreCarsharings() {
        this.getCarsharings({
            skip: this.carsharings.length,
            limit: 5,
            fromLoadMore: true
        });
    }

    getRentsCount() {
        return new Promise((resolve) => {
            const rentStatuses = _(RentStatus).values().without(RentStatus.INIT, RentStatus.CANCELLED).value();
            this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
            this.$store.dispatch(GET_RENTS, {
                callback: function (data) {
                    this.rentsCount = data.count;
                    this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                    resolve(data.count);
                }.bind(this),
                data: {
                    conditions: {
                        status: {$in: rentStatuses},
                        ...this.conditions.date
                    },
                    count: true,
                }
            });
        })
    }
    getRents(params) {
        const rentStatuses = _(RentStatus).values().without(RentStatus.INIT, RentStatus.CANCELLED).value();
        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
        this.$store.dispatch(GET_RENTS, {
            callback: function (data) {
                this.rents = [...this.rents, ...data];
                this.hasBookings = this.hasBookings || this.rents.length > 0;
                if(params.fromLoadMore) this.scrollToElement('rentLoadMoreButton');
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
            }.bind(this),
            data: {
                conditions: {
                    status: {$in: rentStatuses},
                    ...this.conditions.date
                },
                skip: params?.skip || 0,
                limit: params?.limit || 5,
                sort: {
                    'from.date': -1
                }
            }
        });
    }
    loadMoreRents() {
        this.getRents({
            skip: this.rents.length,
            limit: 5,
            fromLoadMore: true
        });
    }

    getParksCount() {
        return new Promise((resolve) => {
            const parkStatuses = _(ParkStatus).values().without(ParkStatus.INIT, ParkStatus.CANCELLED).value();
            this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
            this.$store.dispatch(GET_PARKS, {
                callback: function (data) {
                    this.parksCount = data.count;
                    this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                    resolve(data.count);
                }.bind(this),
                data: {
                    conditions: {
                        status: {$in: parkStatuses},
                        ...this.conditions.date
                    },
                    count: true,
                }
            });
        })
    }

    getParks(params) {
        const parkStatuses = _(ParkStatus).values().without(ParkStatus.INIT, ParkStatus.CANCELLED).value();
        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
        this.$store.dispatch(GET_PARKS, {
            callback: function (data) {
                this.parks = [...this.parks, ...data];
                this.hasBookings = this.hasBookings || this.parks.length > 0;
                if(params.fromLoadMore) this.scrollToElement('parkLoadMoreButton');
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
            }.bind(this),
            data: {
                conditions: {
                    status: {$in: parkStatuses},
                    ...this.conditions.date
                },
                skip: params?.skip || 0,
                limit: params?.limit || 5,
                sort: {
                    'from.date': -1
                }
            }
        });
    }
    loadMoreParks() {
        this.getParks({
            skip: this.parks.length,
            limit: 5,
            fromLoadMore: true
        });
    }
    toggleFiltersModal() {
        this.showFiltersModal = !this.showFiltersModal;
    }

    resetFilters() {
        this.selectedYear = this.initialValues.selectedYear;
        this.selectedMonth = this.initialValues.selectedMonth;
        this.selectedService = this.initialValues.selectedService;
    }

    submitFilters() {
        this.toggleFiltersModal();
        this.getBookings();
    }

    selectFilterService(service) {
        this.selectedService = service;
    }

    countResults() {
        this.loading = true;
        let carsharingEnded = false;
        let rentEnded = false;
        let parkEnded = false;
        const isCountLoading = () => {
            if(carsharingEnded && rentEnded && parkEnded) {
                this.loading = false;
            }
        }
        switch(this.selectedService){

            case 'carsharing':
                this.getCarsharingsCount().then((count) => {
                    this.count = count;
                    this.loading = false;
                });
                break;
            case 'rent':
                this.getRentsCount().then((count) => {
                    this.count = count;
                    this.loading = false;
                });
                break;
            case 'park':
                this.getParksCount().then((count) => {
                    this.count = count;
                    this.loading = false;
                });
                break;
            default:
                this.count = 0;
                this.getCarsharingsCount().then((count) => {
                    this.count += count;
                    carsharingEnded = true;
                    isCountLoading();
                })
                this.getRentsCount().then((count) => {
                    this.count += count;
                    rentEnded = true;
                    isCountLoading();
                })
                this.getParksCount().then((count) => {
                    this.count += count;
                    parkEnded = true;
                    isCountLoading();
                })

                break;
        }
    }

    get conditions() {
        const gte = this.selectedYear + (this.selectedMonth !== '0' ? '-' + this.selectedMonth.padStart(2, '0') : '');
        const lt = this.selectedMonth === '0'
            ? (parseInt(this.selectedYear) + 1).toString()
            : this.selectedYear + '-' + (parseInt(this.selectedMonth) + 1).toString().padStart(2, '0');
        return {
            service: this.selectedService,
            date: this.selectedYear !== '0' ? {"$and": [{"created": {"$gte": gte}},{"created": {"$lt": lt}}]} : {},
        }
    }

    get months() {
        return {
            '0': this.$t('personal-account.bookings.filter.all'),
            '1': this.$t('personal-account.bookings.filter.january'),
            '2': this.$t('personal-account.bookings.filter.february'),
            '3': this.$t('personal-account.bookings.filter.march'),
            '4': this.$t('personal-account.bookings.filter.april'),
            '5': this.$t('personal-account.bookings.filter.may'),
            '6': this.$t('personal-account.bookings.filter.june'),
            '7': this.$t('personal-account.bookings.filter.july'),
            '8': this.$t('personal-account.bookings.filter.august'),
            '9': this.$t('personal-account.bookings.filter.september'),
            '10': this.$t('personal-account.bookings.filter.october'),
            '11': this.$t('personal-account.bookings.filter.november'),
            '12': this.$t('personal-account.bookings.filter.december'),
        }
    }
    get years() {
        let startYear = 2006;
        const endDate = new Date().getFullYear();
        let years = {'0': this.$t('personal-account.bookings.filter.all')};
        for (let i = startYear; i <= endDate; i++) {
            years[startYear] = startYear;
            startYear++;
        }
        return years;
    }

    checkFutureBooking() {
        this.getCarsharingsCount(new Date()).then((count) => {
            if(count > 0) {
                this.hasFutureBooking = true;
            }
        });
    }
}
</script>

<style lang="scss" scoped>
.Bookings {
    width: 100%;

    @media (max-width: $f2m-desktop-breakpoint) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 150px);
        position: relative;
    }


    &-container {
        flex-grow:1;
        margin-bottom: 28px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: 100%;
        }

    }

    &-globalContainer {
        display: flex;
        gap: 38px;

        @media (max-width: $f2m-desktop-breakpoint) {
            gap: 0;
        }
    }

    &-title {
        margin-bottom: 36px;
    }

    &-allServiceContainer{
        display: flex;
        flex-direction: column;
        gap: 28px;
        margin-bottom: 28px;
        flex-grow: 1;
    }

    &-serviceContainer{
        width: 100%;
    }

    &-service {
        font-size: 18px;
        line-height: 22px;
        color: white;
        font-weight: bold;
        margin-left: 12px;
        margin-bottom: 12px;

    }

    &-year {
        margin: 28px 28px 16px;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.3px;
    }

    &-loadMoreButton {
        margin: 12px auto;
    }

    &-loadMoreContainer {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    &-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        height: 100%;
        color: #fff;
        margin-top: 50px;
        max-width: 495px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: 100%;
        }

        &Icon {
            font-size: 123px;
            display: block;
            margin-bottom: 42px;
        }

        &Title {
            font-size: 30px;
            line-height: 36px;
            margin-bottom: 24px;
        }

        &Description {
            font-weight: 400;
            font-size: 18px;
            line-height: 22px;
            letter-spacing: 0.3px;
            max-width: 320px;
        }
    }

    &-filter {
        margin: 38px 0 0 0;

        @media (max-width: $f2m-desktop-breakpoint) {
            margin: 0;
        }
    }

    &-filterButton {
        @media (max-width: $f2m-desktop-breakpoint) {
            position: fixed;
            right: 20px;
            bottom: 40px;
            z-index: 1;
        }
    }
    &-filterModalHeader{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 185px;
        margin-bottom: 48px;

        @media (max-width: $f2m-desktop-breakpoint) {
            margin-top: 60px;
        }
    }

    &-filterModalHeaderTitle{
        font-size: 30px;
        line-height: 36px;
        font-weight: bold;
        letter-spacing: 0.818182px;
        color: $color-white;
    }

    &-filterModalFooter {
        background-color: $color-white;
        padding: 15px;
    }

    &-filterModalSubTitle{
        font-size: 22px;
        line-height: 26px;
        color: $color-white;
        margin-bottom: 15px;
    }

    &-filterModalServiceContainer{
        .row{
            margin-bottom: 20px;
            &:last-child{
                margin-bottom: 40px;
            }
        }
    }

    &-filterModalServiceButton {
        width: 100%;
    }

    &-filterModalDateContainer {
        .col {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        margin-bottom: 20px;
    }
    &-filterModalFooterButton {
        width: 100%;
    }
}
</style>
